import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { industries } from '../mockData';
import Newsletter from '../components/Newsletter';

const Industries = () => {
  return (
    <div className="min-h-screen bg-black">
      {/* Hero Section */}
      <section className="relative pt-24 sm:pt-32 pb-12 sm:pb-20 overflow-hidden bg-gradient-to-br from-black via-[#1a1a1a] to-black">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute bottom-20 left-10 w-96 h-96 bg-[#C9A55A]/20 rounded-full blur-3xl"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="luxury-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white mb-4 sm:mb-6">
            Industries We <span className="text-[#C9A55A]">Serve</span>
          </h1>
          <p className="text-base sm:text-lg md:text-xl text-gray-300 max-w-3xl mx-auto px-4">
            Deep expertise and proven results across diverse sectors
          </p>
        </div>
      </section>

      {/* Industries Grid */}
      <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-b from-black to-[#0a0a0a]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {industries.map((industry) => (
              <Card key={industry.id} className="luxury-card bg-white/5 border-white/10 hover:border-[#C9A55A]/50 overflow-hidden group cursor-pointer">
                <div className="relative h-48 sm:h-56 md:h-64 overflow-hidden">
                  <img 
                    src={industry.image} 
                    alt={industry.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent"></div>
                </div>
                <CardContent className="p-6 sm:p-8 -mt-16 sm:-mt-20 relative z-10">
                  <h3 className="luxury-heading text-xl sm:text-2xl text-white mb-2 sm:mb-3">{industry.name}</h3>
                  <p className="text-gray-300 text-sm sm:text-base leading-relaxed">{industry.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Why We're Different */}
      <section className="py-12 sm:py-16 md:py-20 bg-[#0a0a0a]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-12 md:mb-16">
            <h2 className="luxury-heading text-3xl sm:text-4xl md:text-5xl text-white mb-4 sm:mb-6">Cross-Sector Excellence</h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed px-4">
              Our diverse industry experience enables unique insights and strategic advantages for our clients
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
            <Card className="standard-card bg-gradient-to-br from-white/5 to-white/[0.02] border-white/10">
              <CardContent className="p-6 sm:p-8 text-center">
                <div className="w-16 h-16 bg-[#C9A55A]/10 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6 border border-[#C9A55A]/20">
                  <span className="text-[#C9A55A] text-2xl font-bold">10+</span>
                </div>
                <h3 className="text-lg sm:text-xl font-semibold text-white mb-2 sm:mb-3">Years of Experience</h3>
                <p className="text-gray-400 text-xs sm:text-sm leading-relaxed">
                  Decade of proven success across government, private sector, and international markets
                </p>
              </CardContent>
            </Card>

            <Card className="standard-card bg-gradient-to-br from-white/5 to-white/[0.02] border-white/10">
              <CardContent className="p-6 sm:p-8 text-center">
                <div className="w-16 h-16 bg-[#C9A55A]/10 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6 border border-[#C9A55A]/20">
                  <span className="text-[#C9A55A] text-2xl font-bold">4</span>
                </div>
                <h3 className="text-lg sm:text-xl font-semibold text-white mb-2 sm:mb-3">Global Markets</h3>
                <p className="text-gray-400 text-xs sm:text-sm leading-relaxed">
                  Operating across North America, Europe, Middle East, and international trade corridors
                </p>
              </CardContent>
            </Card>

            <Card className="standard-card bg-gradient-to-br from-white/5 to-white/[0.02] border-white/10">
              <CardContent className="p-6 sm:p-8 text-center">
                <div className="w-16 h-16 bg-[#C9A55A]/10 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6 border border-[#C9A55A]/20">
                  <span className="text-[#C9A55A] text-2xl font-bold">100%</span>
                </div>
                <h3 className="text-lg sm:text-xl font-semibold text-white mb-2 sm:mb-3">Client Satisfaction</h3>
                <p className="text-gray-400 text-xs sm:text-sm leading-relaxed">
                  Trusted by government ministries, corporations, and high-net-worth individuals
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      <Newsletter />
    </div>
  );
};

export default Industries;